import React, { useState } from 'react'
import { IconClock, IconLock, IconExternalLink } from '@tabler/icons-react'

//@ts-ignore
import { Button, Badge } from 'dsm-react-lib'
import { ButtonSpinner } from '../../styles/common'
import { useArcRequest } from '../../_hooks/useArcRequest'
import ArcRequestModal from './ArcRequestModal'
//@ts-ignore
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { getLayoutModel, workspaceSchema } from '../_pages/Work-space/constants'
import { useRecentlyOpenedAppsServices } from '../../_services/RecentlyOpenedAppsService'

const StyledDropdownToggle = styled(DropdownToggle)`
  margin-left: -30px;
  padding: 0px 0px 0px 0.5rem;

  &::after {
    top: 1px;
    right: 0;
    left: -5px;
    padding: 0.8rem;
  }
  &.dropdown-toggle {
    .visually-hidden {
      display: none;
    }
  }
`

interface AppAccesButtonProps {
  application: any
  params: any
  onOpenApp: (workspace?: string | undefined) => void
  size?: 'large' | 'medium' | 'small'
  isPreview?: boolean
  hasSuggestedApps?: boolean
}

export const AppAccessButton: React.FC<AppAccesButtonProps> = ({
  application,
  params,
  onOpenApp,
  size = 'medium',
  isPreview = false,
  hasSuggestedApps
}) => {
  const [isBtnDisabled, setIsBtnDisabled] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedArcRoles, setSelectedArcRoles] = useState([])
  const { handleSilentArcRequest, isArcRoleLoading } = useArcRequest()
  const { workspaceList, activeWorkspace } = useSelector(
    (state: any) => state.workspaceReducer.workspaces
  )
  const { addRecentlyOpenedApp } = useRecentlyOpenedAppsServices()

  const classNames = `${
    size === 'large' ? 'btn-lg mt-1' : size === 'small' ? 'btn-sm justify-content-center p-1' : ''
  } d-flex align-items-center`

  const onArcModalAccess = () => {
    setIsBtnDisabled(!isBtnDisabled)
    setIsModalOpen((prevState) => !prevState)
  }

  const onSilentAccess = async () => {
    setIsBtnDisabled(true)
    await handleSilentArcRequest({
      application,
      selectedArcRoles: selectedArcRoles?.length
        ? selectedArcRoles
        : application.arc?.arcRoles || []
    })
    setIsBtnDisabled(false)
  }

  const renderButton = () => {
    if (!params?.isInProcess && params?.arcRoles?.length) {
      return (
        <Button
          label={!isArcRoleLoading ? 'Request access' : 'Requesting'}
          color="warning"
          className={classNames}
          icon={!isArcRoleLoading ? <IconLock size={18} /> : <ButtonSpinner color="white" />}
          style={{ width: size === 'small' ? '164px' : 'auto' }}
          onClick={params.hideArcRoles ? onSilentAccess : onArcModalAccess}
          disabled={isBtnDisabled || isPreview}
          iconOnly={false}
          data-testid="requestAccessBtn"
        />
      )
    } else if (params?.isInProcess) {
      return (
        <Button
          label="Pending access"
          color="warning"
          icon={<IconClock size={18} />}
          className={`cursor-not-allowed w-auto ${classNames}`}
          style={{ width: size === 'small' ? '164px' : 'auto' }}
          disabled={true}
          iconOnly={false}
          data-testid="pendingAccessBtn"
        />
      )
    } else if (!params?.isInProcess && !params?.arcRoles?.length) {
      return (
        <UncontrolledDropdown group className="w-auto">
          <Button
            label="Open"
            color="primary"
            style={{ width: size === 'small' ? '164px' : '' }}
            className={classNames}
            disabled={isPreview}
            icon={<IconExternalLink size={18} />}
            onClick={() => {
              addRecentlyOpenedApp(application)
              // Always use activeWorkspace from Redux instead of hardcoding 'my-workspace'
              onOpenApp(activeWorkspace || 'my-workspace')
            }}
            iconOnly={false}
            data-testid="openApp"
          />
          {!hasSuggestedApps &&
            (() => {
              const modifiedWorkspaceList = [...workspaceList]

              if (
                !modifiedWorkspaceList.some((workspace: any) => workspace.id === 'my-workspace')
              ) {
                modifiedWorkspaceList.push({
                  ...workspaceSchema,
                  model: getLayoutModel([], undefined)
                })
              }

              return (
                <>
                  <StyledDropdownToggle
                    caret
                    color="primary"
                    className={size === 'large' ? 'mt-1' : ''}
                  />
                  <DropdownMenu>
                    {modifiedWorkspaceList.map((workspace: any) => (
                      <DropdownItem key={workspace.id}>
                        {workspace.name === 'Primary Workspace' ? (
                          <div onClick={() => onOpenApp(workspace.id)}>
                            {workspace.name}
                            <Badge
                              className="ms-1"
                              color="info"
                              label="default"
                              type="pill"
                              variant="outlined"
                            />
                          </div>
                        ) : (
                          <div onClick={() => onOpenApp(workspace.id)}>{workspace.name}</div>
                        )}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </>
              )
            })()}
        </UncontrolledDropdown>
      )
    }
  }

  return (
    <>
      {renderButton()}
      {isModalOpen && (
        <ArcRequestModal
          isOpen={isModalOpen}
          toggle={onArcModalAccess}
          arcRoles={application.arc?.arcRoles}
          handleOnRequest={onSilentAccess}
          setSelectedArcRoles={setSelectedArcRoles}
          selectedArcRoles={selectedArcRoles}
        />
      )}
    </>
  )
}
